import { change, getFormValues } from 'redux-form'
import * as Effects from 'redux-saga/effects'
import { ICopyAddressValues } from '../../../actions/bookingCalendar/reservationModal/copyAddressValues'
import { ICreateReservationFormValues } from '../../../containers/Form/CreateReservation/CreateReservation'
import { IGuestInfo } from '../../../models/Event'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

function* copyAddressValues(action: ICopyAddressValues) {
  const getForm = getFormValues(action.formName)
  const values: ICreateReservationFormValues = yield Effects.select(getForm)

  const { guest } = values
  const addressInfo: IGuestInfo = (({
    street,
    houseNumber,
    apartmentNumber,
    city,
    postCode,
    country,
  }) => ({ apartmentNumber, city, country, houseNumber, postCode, street }))(
    guest,
  )
  yield Effects.put(
    change(action.formName, action.additionalGuestKey, guest => ({
      ...guest,
      ...addressInfo,
    })),
  )
}

export default function* () {
  yield Effects.takeLatest(
    ReservationModalActions.CopyAddressValues,
    copyAddressValues,
  )
}
